import clsx from 'clsx'; // @ts-ignore

import mathup from 'mathup';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ArticleContentMath = _ref => {
  let {
    className = '',
    options = {},
    children
  } = _ref;
  const domStr = mathup(children, options).toString().replace(/^<math>/, '<math xmlns="http://www.w3.org/1998/Math/MathML">');
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles.mathEquation, className),
    dangerouslySetInnerHTML: {
      __html: domStr
    }
  });
};

export default ArticleContentMath;